module.exports = __webpack_public_path__ + "img/laft_bg2.ab2bb813.png";